export interface HLSConfig {
  enableWorker: boolean;
  autoStartLoad: boolean;
  startLevel: number;
  initialLiveManifestSize: number;
  maxBufferLength: number;
  maxMaxBufferLength: number;
  backBufferLength: number;
  abrEwmaDefaultEstimate: number;
  maxBufferHole: number;
  highBufferWatchdogPeriod: number;
  nudgeOffset: number;
  progressive: boolean;
  lowLatencyMode: boolean;
  testBandwidth: boolean;
  appendErrorMaxRetry: number;
  levelLoadingTimeOut: number;
  levelLoadingMaxRetry: number;
  levelLoadingRetryDelay: number;
  debug: boolean;
  capLevelToPlayerSize: boolean;
  smoothAutoSwitch: boolean;
  startFragPrefetch: boolean;
  maxBufferSize: number;
  maxStarvationDelay: number;
  maxLoadingDelay: number;
  minAutoBitrate: number;
}

export function useHLSConfig(): HLSConfig {
  return {
    enableWorker: true,
    autoStartLoad: true,
    startLevel: -1,
    initialLiveManifestSize: 1,
    maxBufferLength: 30,
    maxMaxBufferLength: 600,
    backBufferLength: 90,
    abrEwmaDefaultEstimate: 1000000,
    maxBufferHole: 0.5,
    highBufferWatchdogPeriod: 2,
    nudgeOffset: 0.2,
    progressive: true,
    lowLatencyMode: false,
    debug: false,
    capLevelToPlayerSize: true,
    smoothAutoSwitch: true,
    startFragPrefetch: true,
    testBandwidth: true,
    maxBufferSize: 60 * 1000 * 1000,
    maxStarvationDelay: 4,
    maxLoadingDelay: 4,
    minAutoBitrate: 0,
    levelLoadingTimeOut: 10000,
    levelLoadingMaxRetry: 4,
    levelLoadingRetryDelay: 1000,
    appendErrorMaxRetry: 3
  };
}
